import React, { FunctionComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field, FormikErrors, FormikValues } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {
  proceedToNextFormStep,
  goBack,
} from "../../../actions/diversityFormActions";
import RadioButton from "../../shared/publicForms/RadioButton";
import TextField from "../../shared/publicForms/TextField";
import {
  StepWrapper,
  Title,
  RadioButtonGroupWrapper,
  RadioButtonGroup,
  BackButton,
  ButtonsWrapper,
  Button,
  DisabledButton,
} from "../styles/diversity-form-styles";

export interface IGenderProps {
  values: {
    gender?: undefined | string;
  };
  errors: FormikErrors<FormikValues>;
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate: boolean
  ) => void;
  proceedToNextFormStepAction: typeof proceedToNextFormStep;
  goBackAction: typeof goBack;
}

export const Gender: FunctionComponent<IGenderProps> = ({
  values,
  errors,
  proceedToNextFormStepAction,
  goBackAction,
  setFieldValue,
}) => {
  const radioButtonOptions = [
    null,
    "Male",
    "Female",
    "Non-binary",
    "Other",
    "Prefer not to say",
  ];

  return (
    <StepWrapper data-test-id="gender-step" formStep>
      <Title data-test-id="title">How would you describe your gender?</Title>
      <RadioButtonGroupWrapper
        role="group"
        aria-labelledby="gender-radio-group"
      >
        <RadioButtonGroup width={185}>
          {radioButtonOptions
            .filter((option) => option)
            .map((option) =>
              option === "Other" ? (
                <Fragment key={option}>
                  <Field
                    name="gender"
                    type="radio"
                    aria-label={option}
                    label={option}
                    value={option}
                    onChange={() => setFieldValue("gender", "", true)}
                    checked={!radioButtonOptions.includes(values.gender)}
                    as={RadioButton}
                  />
                  {!radioButtonOptions.includes(values.gender) && (
                    <Field
                      name="gender"
                      type="text"
                      aria-label={values.gender}
                      placeholder="Please specify"
                      as={TextField}
                    />
                  )}
                </Fragment>
              ) : (
                <Field
                  key={option}
                  name="gender"
                  type="radio"
                  aria-label={option}
                  label={option}
                  value={option}
                  as={RadioButton}
                />
              )
            )}
        </RadioButtonGroup>
      </RadioButtonGroupWrapper>
      <ButtonsWrapper>
        <BackButton type="button" onClick={goBackAction}>
          <FontAwesomeIcon icon={faChevronLeft} />
          back
        </BackButton>
        {values.gender && !errors.gender ? (
          <Button
            type="button"
            onClick={proceedToNextFormStepAction}
            data-test-id="next-button"
          >
            Next
          </Button>
        ) : (
          <DisabledButton type="button">Next</DisabledButton>
        )}
      </ButtonsWrapper>
    </StepWrapper>
  );
};

Gender.propTypes = {
  values: PropTypes.shape({
    gender: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    gender: PropTypes.string,
  }).isRequired,
  proceedToNextFormStepAction: PropTypes.func.isRequired,
  goBackAction: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default connect(null, {
  proceedToNextFormStepAction: proceedToNextFormStep,
  goBackAction: goBack,
})(Gender);
